import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChanges,
  ElementRef
} from '@angular/core';
import { adjustWith2DecimalsForUI } from '../commonfunctions/commonFunction';

@Component({
  selector: 'app-life-insurance-tile',
  templateUrl: './life-insurance-tile.component.html',
  styleUrl: './life-insurance-tile.component.scss',
})
export class LifeInsuranceTileComponent implements OnInit, OnChanges {
  @Input() plan: any;
  @Input() product: any;
  @Input() k: number = 0;
  @Input() coverage: any;
  @Input() pkg: any;
  @Input() group: any;
  @Input() allFormData: any = {};
  @Input() lang: any = {};
  @Input() userForm: any;
  @Input() possibleCoverage: any;

  @Output() checkboxChangePEvent  = new EventEmitter<any>();
  @Output() radioChangeEvent      = new EventEmitter<any>();
  @Output() rangeChangeEvent      = new EventEmitter<any>();
  @Output() radioChangeV2Event    = new EventEmitter<any>();
  @Output() rangeChangeV2Event    = new EventEmitter<any>();

  rangeValues:   any[]    = [];
  greenValue:    any      = 0;
  showyellowbar: boolean  = false;
  yellowValue:   any      = 0;
  selectedPeople:any =[];
  enableSlider:any = false;
  showFamPrice: any =false;


  constructor(public elementRef: ElementRef){}


  get isAllStatePlan(): boolean {
    return this.plan?.id === 908;
  }

  get isSinglePlan(): boolean {
    return this.userForm?.get('having_spouse')?.value            !== 'true'
        && this.userForm?.get('having_dependent_children')?.value !== 'true';
  }

  get hasSpouse(): boolean {
    return this.userForm?.get('having_spouse')?.value === 'true';
  }

  get addonKey(): string {
    return String(
      this.plan?.productAddonss?.[this.product]?.[this.k]?.id
        ?? this.plan?.planCoverage
    );
  }

  ngOnInit(): void {
    this.computeRangeValues();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['plan'] || changes['k'] || changes['product']) {
      this.computeRangeValues();
    }
  }

  private computeRangeValues(): void {
    if (this.plan?.productAddonss?.[this.product]?.[this.k]?.member) {
      const member = this.plan.productAddonss[this.product][this.k].member;
      this.rangeValues = this.generateTicks(
        member.maximumCoverageWithEvidence,
        member.minimumCoverage
      );
    }
  }


  public getSliderBackground(
    rangeValue: any,
    maxRange:   any,
    stepCount:  any,
    defaultRange: any
  ): string {
    if (rangeValue <= defaultRange) {
      this.greenValue    = (defaultRange / maxRange) * 100;
      this.showyellowbar = false;
      return `linear-gradient(to right, green ${(defaultRange / maxRange) * 100}%, lightgray 0%)`;
    } else {
      const greenPart  = adjustWith2DecimalsForUI((defaultRange / maxRange) * 100);
      const yellowPart = adjustWith2DecimalsForUI((rangeValue   / maxRange) * 100);
      this.greenValue    = greenPart;
      this.showyellowbar = true;
      return `linear-gradient(to right,
        green    0%,
        green    ${greenPart}%,
        yellow   ${greenPart}%,
        yellow   ${yellowPart}%,
        lightgray ${yellowPart}%,
        lightgray 100%)`;
    }
  }

  public generateTicks(maxRange: any, _stepCount: any): any[] {
    if (!maxRange) { return []; }
    const interval = maxRange / 3;
    return [0, interval, interval * 2, maxRange];
  }

public isDataAvailable(type: string, category: string, field?: string): boolean {
  console.log({allform: this.allFormData, type, category, field})
  
  const categoryData = this.allFormData[type]?.[category];
  
  if (!categoryData) return true; // disabled if category doesn't exist at all
  
  if (field) {
    const value = categoryData[field] ?? categoryData?.coverage?.[field];
    return !value;
  }
  
  return !categoryData;
}


public isDataAvailableAllState(type: string, category: string, field?: string): boolean {
  console.log({allform: this.allFormData, type, category, field})
  
  const categoryData = this.allFormData[type]?.['member'];
  
  if (!categoryData) return true; // disabled if category doesn't exist at all
  
  if (field) {
    const value = categoryData[field] ?? categoryData?.coverage?.[field];
    if(this.hasSpouse){
      const spouseValue = categoryData['isSpouseSmoker'];
      return !spouseValue
    }
    return !value;
  }
  
  return !categoryData;
}

  public isDataAvailableSpouseDataa(type: string, category: string, field?: string): boolean {
    return field
      ? !(this.allFormData[type]?.[category]?.[field])
      : !(this.allFormData[type]?.[category]);
  }

  public isDataAvailableSpouse(type: string, _category: string, _field?: string): boolean {
    return !(this.allFormData[type]?.['member']);
  }


  onCheckboxChangePLocal(
    event:        any,
    planCoverage: string,
    category:     string,
    key1:         string,
    productAddon: any,
    allState:any = false
  ): void {
    console.log("allstate3747: ", allState)

    if(event.target.name && event.target.checked){
      console.log(event.target.name)
      let currCoverage = event.target.name.split('-')[1]
      console.log("currCoverage238383: ",currCoverage)
      if(currCoverage.trim() == 'single'){
        this.showFamPrice = false;
      }else{
        this.showFamPrice = true;
        // Reset radio buttons and slider when switching to Family
        if (this.allFormData[planCoverage]?.['member']) {
          this.allFormData[planCoverage]['member']['isSmoker']      = null;
          this.allFormData[planCoverage]['member']['isSpouseSmoker'] = null;
          this.allFormData[planCoverage]['member']['premium']        = 0;
        }
        // Reset slider back to defaultRange (50k)
        const defaultVal = productAddon?.member?.defaultRange ?? 50000;
        if (productAddon?.member) {
          productAddon.member.maximumCoverageWithoutEvidence = defaultVal;
        }
        // Reset questionnaire / slider state
        this.selectedPeople = [];
        this.enableSlider   = false;
      }
    }
    console.log({ event, planCoverage, category, key1, productAddon })

    this.regenerateRangeValues(planCoverage, 'member');
    this.checkboxChangePEvent.emit({ event, planCoverage, category, key1, productAddon, allState });
  }

  onRadioChangeLocal(
    event:        any,
    planCoverage: string,
    category:     string,
    planOptions:  any,
    planObj:      any,
    productAddon: any,
    pkgObj:       any,
    groupObj:     any,
    coverageData: any
  ): void {
    if (coverageData?.maximumCoverageWithEvidence && coverageData?.minimumCoverage) {
      this.rangeValues = this.generateTicks(
        coverageData.maximumCoverageWithEvidence,
        coverageData.minimumCoverage
      );
    }
    this.radioChangeEvent.emit({
      event, planCoverage, category,
      planOptions, planObj, productAddon,
      pkgObj, groupObj, coverageData
    });
  }

  onRangeChangeLocal(
    event:        any,
    planCoverage: string,
    category:     string,
    planOptions:  any,
    planObj:      any,
    productAddon: any,
    pkgObj:       any,
    groupObj:     any,
    rangeEvent:   any,
    coverageData: any
  ): void {
    if (coverageData?.maximumCoverageWithEvidence && coverageData?.minimumCoverage) {
      this.rangeValues = this.generateTicks(
        coverageData.maximumCoverageWithEvidence,
        coverageData.minimumCoverage
      );
    }
    this.rangeChangeEvent.emit({
      event, planCoverage, category,
      planOptions, planObj, productAddon,
      pkgObj, groupObj, rangeEvent, coverageData
    });
  }

  onRadioChangeV2Local(
    event:        any,
    planCoverage: string,
    category:     string,
    planOptions:  any,
    planObj:      any,
    productAddon: any,
    pkgObj:       any,
    groupObj:     any,
    coverageData: any
  ): void {
    
    console.log("category1233: ", {
      event, planCoverage, category,
      planOptions, planObj, productAddon,
      pkgObj, groupObj, coverageData
    })

    if(category == "member"){
      this.allFormData[planCoverage][category].isSmoker = event.target.value;
    }else{
       this.allFormData[planCoverage]['member'].isSpouseSmoker = event.target.value;
    }


    if(!this.selectedPeople.includes(category)){
      this.selectedPeople.push(category);
    }
    console.log("possibleCoverage123: ",this.possibleCoverage)
    if(this.possibleCoverage == "FAMILY"){
      if(this.selectedPeople >= 2){
        this.enableSlider = true;
      }else{
        this.enableSlider = false;
      }
    }

    if(this.possibleCoverage == "SINGLE"){}

    this.radioChangeV2Event.emit({
      event, planCoverage, category,
      planOptions, planObj, productAddon,
      pkgObj, groupObj, coverageData
    });
  }

  onRangeChangeV2Local(
    event:        any,
    planCoverage: string,
    category:     string,
    planOptions:  any,
    planObj:      any,
    productAddon: any,
    pkgObj:       any,
    groupObj:     any,
    rangeEvent:   any,
    coverageData: any
  ): void {
    if (coverageData?.maximumCoverageWithEvidence && coverageData?.minimumCoverage) {
      this.rangeValues = this.generateTicks(
        coverageData.maximumCoverageWithEvidence,
        coverageData.minimumCoverage
      );
    }
    this.rangeChangeV2Event.emit({
      event, planCoverage, category,
      planOptions, planObj, productAddon,
      pkgObj, groupObj, rangeEvent, coverageData
    });
  }



  
  public getDefaultPremium(type: string, category: string, planType: 'single' | 'family'): number {
    console.log(this.allFormData,type, category, planType)
  const coverage = this.allFormData[type]?.[category]?.coverage;
  if (!coverage) return 0;

  // If premium already calculated (slider was moved), use it
  const existingPremium = this.allFormData[type]?.[category]?.premium;
  if (existingPremium && existingPremium > 0) return existingPremium;

  // Otherwise calculate default from coverage at defaultRange (50k)
  const defaultCoverageValue = coverage.defaultRange ?? 50000;
  const minimumCoverage = coverage.minimumCoverage ?? 25000;
  const units = defaultCoverageValue / minimumCoverage;

  // Get price based on gender and smoker status
  const gender = this.userForm.value.gender?.toLowerCase() ?? 'male';
  const isSmoker = this.allFormData[type]?.[category]?.isSmoker === 'yes';

  let unitPrice = 0;
  if (planType === 'single') {
    unitPrice = coverage.single?.price?.[gender]?.[isSmoker ? 'smoker' : 'nonSmoker'] ?? 0;
  } else {
    unitPrice = coverage.family?.price?.[gender]?.[isSmoker ? 'smoker' : 'nonSmoker'] ?? 0;
  }

  const dynamicPrice = adjustWith2DecimalsForUI(units * unitPrice);
  const staticPrice = coverage.static?.price ?? 0; // static component

  return adjustWith2DecimalsForUI(dynamicPrice + staticPrice);
}

  private getQuestionnaireState(): { hasAnyTrue: boolean; allFalse: boolean; exists: boolean, isFirstQuestionValue:any } {
  const raw = sessionStorage.getItem('allstate_questionnaire');
  if (!raw) return { hasAnyTrue: false, allFalse: false, exists: false, isFirstQuestionValue: false };

  try {
    const questionnaire = JSON.parse(raw);
    console.log(questionnaire)


    let codes = Object.keys(questionnaire.answers);
    let firstQuestion = questionnaire.answers[codes[0]];

    console.log(firstQuestion)

    let remainingAnswers = codes
    .slice(1)
    .map((code: string) => questionnaire.answers[code]) as { value: boolean }[];
    console.log(remainingAnswers)

    const hasAnyTrue = remainingAnswers.some(a => a.value === true);
    const allFalse = remainingAnswers.every(a => a.value === false);
    return { hasAnyTrue, allFalse, exists: true, isFirstQuestionValue:firstQuestion?.value  };
  } catch {
    return { hasAnyTrue: false, allFalse: false, exists: false, isFirstQuestionValue: false };
  }
}

public applyQuestionnaireRestrictions(type: string): void {
  const { hasAnyTrue, allFalse, exists, isFirstQuestionValue } = this.getQuestionnaireState();
  console.log({ hasAnyTrue, allFalse, exists, isFirstQuestionValue });
  if (!exists) return;

  // ✅ First question = No → just uncheck plan (handled in parent), 
  // no slider/coverage restrictions at all
  if (!isFirstQuestionValue) return;

  // Only reach here if first question = Yes
  const categories = ['member'];
  categories.forEach(category => {
    const coverage = this.allFormData[type]?.[category]?.coverage;
    if (!coverage) return;

    if (hasAnyTrue) {
      // Any remaining question = Yes → cap slider at defaultRange
      coverage.maximumCoverageWithEvidence = coverage.defaultRange;
      if (coverage.maximumCoverageWithoutEvidence > coverage.defaultRange) {
        coverage.maximumCoverageWithoutEvidence = coverage.defaultRange;
      }
    } else if (allFalse) {
      // All remaining questions = No → extend green to current value
      const currentValue = coverage.maximumCoverageWithoutEvidence;
      coverage.defaultRange = currentValue > coverage.defaultRange ? currentValue : coverage.defaultRange;
      coverage.maximumCoverageWithEvidence = 100000; // full range stays accessible
      coverage.maximumCoverageWithoutEvidence = currentValue;
      console.log("coveragedata: ", coverage)
    }
  });

  this.regenerateRangeValues(type, 'member');
}

 public  allStateRangeValues:any = [0, 25000, 50000, 75000, 100000];
public regenerateRangeValues(type: string, category: string): void {
  const coverage = this.allFormData[type]?.[category]?.coverage;
  if (!coverage) return;

  this.rangeValues = [];
  for (
    let i = 0;
    i <= coverage.maximumCoverageWithEvidence;
    i += coverage.minimumCoverage
  ) {
    this.rangeValues.push(i);
  }


  console.log("this.rangevalue3993: ",this.rangeValues)
}
}
